import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { interval, Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { MainService } from 'src/app/services/main.service';
import { SharedService } from 'src/app/services/shared.service';
import { SocketsService } from 'src/app/services/socket.service';

@Component({
  selector: 'app-e-consent-modal',
  templateUrl: './e-consent-modal.component.html',
  styleUrl: './e-consent-modal.component.scss'
})
export class EConsentModalComponent {

  modalType!: any;
  extradata!: any;
  // userId!: any;
  constructor(private bsModalRef: BsModalRef, private router: Router, private _api: ApiService, public _sharedService: SharedService, private _main: MainService, private modalService: BsModalService, private _socket: SocketsService) { };
  totalSeconds = 300;   
  displayTime = '04:59';
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Output() outreachStatus: EventEmitter<any> = new EventEmitter();
  private timerSub!: Subscription;
  ngOnInit() {
    // this.startTimer();
    // effect(() => {
    //   this.userId = this._main.consentData()?.user_id;
    //   // this.bsModalRef?.hide();
    // });
     const storedEndTime = localStorage.getItem('outreach_timer_end');
        if (storedEndTime) {
          const endTime = Number(storedEndTime);
          const remainingSeconds = Math.floor((endTime - Date.now()) / 1000);

          if (remainingSeconds > 0) {
            // ✅ User came back to the route, and the timer is still ticking!
            // If they left at 5m and came back 3m later, remainingSeconds will be 120 (2 mins).
            this.totalSeconds = remainingSeconds;
            this.runTimer(); // Resume the visual countdown
          } else {
            // ❌ User came back to the route, but the timer finished while they were gone.
            this.handleTimerExpired();
          }
        } else {
          // ⚪ No active timer exists (First visit, or previously expired)
          this.totalSeconds = 0;
          this.updateDisplay();
        }
  }

  onClose() {
    const data = {
      e_consent_status: 5
    }
    this._api.api(data, '/profile/update_consent', 'post').subscribe((res) => {
      if (res && res.length) {
        console.log(res);

      } else {
        console.log(res.error);
      }
    });
    this.bsModalRef.hide();
  };
  //   goToEConsent() {
  //   // this.bsModalRef.hide();          // close modal
  //   this.router.navigate(['/e-consent']); // navigate
  // }
  goto() {
    this.bsModalRef.hide();
    this.router.navigate(['app/e-consent']);
  }
  goToDashboard() {
    this.router.navigate(['app/dashboard']);
    this.bsModalRef?.hide();
  }
  CloseBrandOutreach() {
    this.passEntry.emit({ success: false });
    this.bsModalRef.hide();
  }

  // startTimer() {

  //   // STOP old timer first
  //   this.timerSub?.unsubscribe();

  //   // RESET time (example 10 minutes)
  //   this.totalSeconds = (4 * 60) + 59;

  //   this.updateDisplay();

  //   this.timerSub = interval(1000).subscribe(() => {

  //     if (this.totalSeconds > 0) {
  //       this.totalSeconds--;
  //       this.updateDisplay();
  //     } else {
  //       this.timerSub.unsubscribe();
  //     }
  //   });
  // }
  startTimer() {
    const durationInSeconds = 300; // 5 minutes

    // Calculate the exact millisecond in the future when this timer should end
    const endTime = Date.now() + (durationInSeconds * 1000);

    // Save this target timestamp to storage EXACTLY ONCE
    localStorage.setItem('outreach_timer_end', endTime.toString());

    this.runTimer();
  }
  // 2. Call this on ngOnInit() to resume a timer, OR from startNewTimer()
  runTimer() {
    this.timerSub?.unsubscribe();
    this.updateDisplay(); // update UI instantly before the first 1s delay

    this.timerSub = interval(1000).subscribe(() => {
      const storedEndTime = localStorage.getItem('outreach_timer_end');

      if (!storedEndTime) {
        this.handleTimerExpired();
        return;
      }

      const endTime = Number(storedEndTime);
      const remainingSeconds = Math.floor((endTime - Date.now()) / 1000);

      if (remainingSeconds > 0) {
        this.totalSeconds = remainingSeconds;
        this.updateDisplay();
      } else {
        this.handleTimerExpired();
      }
    });
  }

    // 3. Centralized Expiry Logic
  handleTimerExpired() {
    this.timerSub?.unsubscribe();
    this.totalSeconds = 0;
    this.updateDisplay();
    localStorage.removeItem('outreach_timer_end');
    // if (this.business_brand_outreach == 1) {
    //   this.business_brand_outreach = 0;
    // }
  }

  // updateDisplay() {
  //   const minutes = Math.floor(this.totalSeconds / 60);
  //   const seconds = this.totalSeconds % 60;

  //   this.displayTime = `${this.pad(minutes)}:${this.pad(seconds)}`;
  // }

  // pad(val: number): string {
  //   return val < 10 ? '0' + val : val.toString();
  // }
    updateDisplay() {
    const minutes = Math.floor(Math.max(this.totalSeconds, 0) / 60);
    const seconds = Math.max(this.totalSeconds, 0) % 60;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
    this.displayTime = `${formattedMinutes}:${formattedSeconds}`;
  }
  resendEmail() {
    this._api.api({}, '/profile/send_outreach_email', 'post').subscribe((res) => {
      console.log("Email Outreach.......", res);
      this.startTimer();
    });

  }

  enableOutreach() {
    this._api.api({}, '/profile/send_outreach_email', 'post').subscribe((res) => {
      console.log("Email Outreach.......", res)
    });
    this.bsModalRef?.hide();
    setTimeout(() => {
      this.bsModalRef = this.modalService.show(EConsentModalComponent, {
        initialState: {
          modalType: this._sharedService.modalTypes.awaitingApproval
        },
        class: 'modal-dialog-centered',
        backdrop: 'static',
        keyboard: false
      });
    }, 1000);
    this.startTimer();
  }
   revokeOutreach() {
    this._api.api(this.extradata, '/profile/revoke_business_outreach', 'post').subscribe((res) => {
      this._main.consentData.set({ business_brand_outreach: '0' });
    });
    this.bsModalRef?.hide();
    this.outreachStatus.emit({ brand_outreach_status : '0' });
  };
  cancelOutreach(){
        this.bsModalRef?.hide();
    
  }
  ngOnDestroy() {
    this.timerSub?.unsubscribe();
  }
}
